import { ConstantApi } from 'api/ConstantApi';
import { backendApiClient } from 'container/backendApiClient';

export const constantApi = new ConstantApi(backendApiClient);
